import axios from 'axios';
import { TOKEN_KEY } from './Auth';
import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
});

const token = localStorage.getItem(TOKEN_KEY);
if (token) api.defaults.headers['Authorization'] = `Bearer ${token}`;

export default api;
